import { Link } from "react-router-dom";
import { useSync } from "@/hooks/useSync";
import { describeStatus } from "@/lib/sync";
import { cn } from "@/lib/utils";

/**
 * The header badge (docs/09 §9.1, principle 3).
 *
 * "The user knows the state at a glance." It is a link, because when
 * something needs attention the volunteer must be able to reach the queue.
 */
export function SyncBadge() {
  const status = useSync();
  const { label, tone } = describeStatus(status);

  const toneClass = {
    ok: "bg-green-50 text-green-800 ring-green-200",
    pending: "bg-amber-50 text-amber-900 ring-amber-200",
    busy: "bg-blue-50 text-blue-800 ring-blue-200",
    error: "bg-red-50 text-red-800 ring-red-200",
  }[tone];

  return (
    <Link
      to="/queue"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ring-1 ring-inset",
        toneClass,
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "h-2 w-2 rounded-full",
          tone === "ok" && "bg-green-600",
          tone === "pending" && "bg-amber-600",
          tone === "busy" && "animate-pulse bg-blue-600",
          tone === "error" && "bg-red-600",
        )}
      />
      {label}
    </Link>
  );
}
